import { resultArticle, source } from '../constants';
import myFetchWithId, { exportWithId } from '../helpers/myFetch';
import { requestFetchApi , receiveFetchApi } from './search.actions';


const transfer = (json) => {
  try {
    if (json.response_status === "SUCCESS" && json.docs.docs) {
      const docs = Object.values(json.docs.docs);
      // weight => for sort 2020 10 05
      const weight = Object.values(json.docs.lowiweight);
      const score = [];
  
      for (let item in json.docs.lowiscore) {
        const value = Number(json.docs.lowiscore[item].$).toFixed(2);
        score.push(value);
      }
      for (let i = 0; i < docs.length; i++) {
        docs[i].relevance = weight[i];
        docs[i].lowiScore = score[i];
      }
  
      return docs;
    }
    else {
      return [];
    }
  } catch (error) {
    console.log(error)
    return [];
  }
}

export function localFetchResult(keyword, sentiment, sort, page, widgetId, posttype, isDashboard,authorKey) {
  let params = {
      text: keyword,
      glb_posttype: posttype,
      glb_sentiment: sentiment,
      sorts: sort,
      page: page,
      score: '3',
      items: 30,
      authorKey:authorKey, //在作者查詢 call qdocs 的條件
    };
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }

  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    return myFetchWithId(widgetId, false, true)(`${process.env.REACT_APP_API}/q/qdocs`, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveResultList(json))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };

}

function receiveResultList(json) {
  return {
    type: resultArticle.RECEIVE,
    resultList: transfer(json),
    totalHits: json.docs.autnQueryResponse ? json.docs.autnQueryResponse.totalhits ? json.docs.autnQueryResponse.totalhits : 0 : 0,
    totalpage: json.docs.autnQueryResponse ? Math.ceil(json.docs.autnQueryResponse.totalhits/30) ? Math.ceil(json.docs.autnQueryResponse.totalhits/30) : 0 : 0,
    lastUpdated: Date.now()
  }

}

export function exportQdocs(keyword, sentiment, sort, page, widgetId, posttype, isDashboard, author, sdate, edate, score, replaceGlobalParams, globalParams) {
  let params = {
      text: keyword,
      glb_posttype: posttype,
      glb_sentiment: sentiment,
      glb_author: author,
      sorts: sort,
      page: page,
      sdate: sdate,
      edate: edate,
      items: 30,
      score: score,
    };
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }
  if(replaceGlobalParams){
    params = {
      ...params,
      ...globalParams,
      replaceGlobalParams:replaceGlobalParams,
    }
  }

  return exportWithId(widgetId, false, true)(`${process.env.REACT_APP_API }/q/qdocs_export`, params);
}

// export function fetchtext(word, quarterTimes, widgetId, sorts, isDashboard) {
//   let params = {
//       text: word,
//   };
//   let quarterTime = quarterTimes;
//   // if we want todo something differently from non dashboard widget, we can add the or remove the params here
//   if (isDashboard) {
//     delete params.glb_sentiment;
//   }
//   return myFetchWithId(widgetId, false, true)(`${process.env.REACT_APP_API}/q/rendertest`, params)
//     // directly call back to the Result widget, not through redux
//     .then(json => receiveOneDayArticle(json, sorts, quarterTime))
// }

export function fetchOneDayArticle(apiParams) {
  let params = {
      text: apiParams.keyword,
      glb_posttype: apiParams.posttype,
      glb_sentiment: apiParams.sentiment,
      sorts: apiParams.sort,
      scope: apiParams.scope,
      items: apiParams.items,
      sdate: apiParams.sdate,
      edate: apiParams.edate,
      score: 3,
  };
  let sorts = apiParams.sort;
  let quarterTime = apiParams.quarterTime;
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (apiParams.isDashboard) {
    delete params.glb_sentiment;
  }

  return dispatch => {
    apiParams.isDashboard ? null : dispatch(requestFetchApi())
    return myFetchWithId(apiParams.widgetId, false, true)(`${process.env.REACT_APP_API}/q/qdocs`, params)
    .then(json =>{
      apiParams.isDashboard ? null : dispatch(receiveFetchApi(json,apiParams.widgetId))
      return dispatch(receiveOneDayArticle(json, sorts, quarterTime))
    })
    .catch(err => {
      apiParams.isDashboard ? null : dispatch(receiveFetchApi(err,apiParams.widgetId))
      console.log(err)
    })
  };

  // return myFetchWithId(apiParams.widgetId, false, true)(`${process.env.REACT_APP_API}/q/qdocs`, params)
  //   // directly call back to the Result widget, not through redux
  //   .then(json => receiveOneDayArticle(json, sorts, quarterTime))
}

function receiveOneDayArticle(json, sorts, quarterTime) {
  const articles = transfer(json);
  const dataForBubble = [];
  const zValue = sorts==='GLBNUM_TOTALCOMMENTCOUNT:numberdecreasing' ? 'GLBNUM_TOTALCOMMENTCOUNT'
    : sorts==='Relevance' ? 'relevance'
    : sorts==='autn_user_LOWISCORE:numberdecreasing' ? 'lowiScore'
    : sorts==='Relevance' ? 'relevance'
    : sorts==='GLBNUM_TOTALLIKECOUNT:numberdecreasing' ? 'GLBNUM_TOTALLIKECOUNT'
    : sorts==='GLBNUM_VIEWCOUNT:numberdecreasing' ? 'GLBNUM_VIEWCOUNT'
    : 'GLBNUM_SHARECOUNT'

  for (let i = 0; i < articles.length; i++) {
    const year = Number(articles[i].GLBTIME_YMD.substr(0, 4));
    const month = Number(articles[i].GLBTIME_YMD.substr(4, 2)) - 1;
    const day = Number(articles[i].GLBTIME_YMD.substr(6, 2));
    const hour = Number(articles[i].GLBTIME_YMDH.substr(8, 1))===0 ? Number(articles[i].GLBTIME_YMDH.substr(9, 1)) : Number(articles[i].GLBTIME_YMDH.substr(8, 2));

    dataForBubble.push({
      x: quarterTime ? Date.UTC(year, month, day, hour) : Date.UTC(year, month, day),
      y: Number(articles[i].GLBTIME_YMDH.substr(-2)),
      z: Number(articles[i][zValue]),
      name: articles[i].GLB_SOURCE,
      title: articles[i].DRETITLE,
      content: articles[i].DRECONTENT,
      link: articles[i].GLBDIS_LINKURL,
      vibe: articles[i].GLB_SENTIMENT,
      date: articles[i].GLBDIS_DISPLAYDATE,
      source: articles[i].GLB_SOURCE,
      author: articles[i].GLB_AUTHOR
    })
  }
  return {
    type: resultArticle.RECEIVE_DIFF_PATH_DATA,
    data: dataForBubble
  } ;
}



// WEBPACK FOOTER //
// ./src/actions/widgetResults.actions.js